import { api } from 'src/utils/api';
// import moment from 'moment';

const loadSurveysRequest =  (params = {}) => api.get(`/survey/sent/${params.pkCompany}`, { params });

const loadSurveyRequest = id => api.get(`/survey/${id}`);

const loadSurveyCompanyRequest = pk_company => api.get(`/survey/company/${pk_company}`);

const syncAnswerRequest = (body, pk_survey_sent) => api.post(`/survey/${pk_survey_sent}/answer`, body);

const completeSurveyRequest = pk_survey_sent => api.post(`/survey/${pk_survey_sent}/complete`);

const loadSurveyAnswers = (pk_survey_sent) => api.get(`/survey/${pk_survey_sent}/answer`);

const createSurveyRequest = ({
    pkSurvey,
    fkCompany,
    ...rest
}) => api.post('/survey', {
    pk_survey: pkSurvey,
    fk_company: fkCompany,
    ...rest
});

export {
    loadSurveysRequest,
    loadSurveyRequest,
    createSurveyRequest,
    syncAnswerRequest,
    completeSurveyRequest,
    loadSurveyAnswers,
    loadSurveyCompanyRequest
};
